var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroundingSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_268)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 50,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 78.7292C52.9808 78.7452 51.9751 78.4937 51.0833 78L50.2083 77.5042C43.3929 73.6482 37.7228 68.0526 33.7772 61.2887C29.8316 54.5247 27.7517 46.8348 27.75 39.0042V38.5959C27.7407 37.563 28.0059 36.5463 28.5183 35.6495C29.0308 34.7527 29.7721 34.0081 30.6667 33.4917L51.0833 22C51.9701 21.488 52.976 21.2185 54 21.2185C55.024 21.2185 56.0299 21.488 56.9167 22L77.3333 33.4917C78.2278 34.0081 78.9692 34.7527 79.4816 35.6495C79.9941 36.5463 80.2592 37.563 80.25 38.5959V39.0042C80.2424 46.8406 78.1538 54.5344 74.1976 61.2989C70.2414 68.0633 64.5596 73.6557 57.7333 77.5042L56.8583 78C55.9837 78.484 54.9995 78.735 54 78.7292ZM54 27.1042L33.5833 38.5959V39.0042C33.5882 45.8032 35.4004 52.4788 38.8342 58.347C42.268 64.2152 47.2 69.0651 53.125 72.4L54 72.8959L54.875 72.4C60.8 69.0651 65.732 64.2152 69.1658 58.347C72.5996 52.4788 74.4117 45.8032 74.4167 39.0042V38.5959L54 27.1042Z",
    fill: "#5f9098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1058 45.9707C63.0613 45.8792 62.9919 45.802 62.9055 45.748C62.8191 45.694 62.7192 45.6654 62.6173 45.6654H56.9608L61.4793 36.1446C61.5186 36.0621 61.5362 35.9709 61.5307 35.8797C61.5251 35.7885 61.4965 35.7002 61.4476 35.6229C61.3986 35.5457 61.3308 35.4821 61.2506 35.4381C61.1704 35.3941 61.0803 35.371 60.9887 35.3711H52.3031C52.1984 35.3711 52.0959 35.4013 52.008 35.4581C51.9201 35.5149 51.8506 35.5958 51.8077 35.6912L44.7507 51.4036C44.7136 51.4861 44.6978 51.5765 44.7047 51.6667C44.7116 51.7569 44.7411 51.8439 44.7903 51.9198C44.8396 51.9957 44.9071 52.0581 44.9867 52.1013C45.0663 52.1445 45.1555 52.1671 45.2461 52.1671H50.5438L47.9727 63.9715C47.9465 64.0912 47.9618 64.2163 48.016 64.3263C48.0703 64.4363 48.1603 64.5247 48.2714 64.5771C48.3825 64.6294 48.508 64.6426 48.6276 64.6145C48.7472 64.5863 48.8536 64.5186 48.9296 64.4222L63.0437 46.5426C63.1068 46.4627 63.146 46.3667 63.157 46.2656C63.168 46.1644 63.1502 46.0623 63.1058 45.9707Z",
    fill: "#5f9098"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_268",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.564706 0 0 0 0 0.596078 0 0 0 1 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.564706 0 0 0 0 0.596078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_268"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_268",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(19 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundingSystem);
export default __webpack_public_path__ + "static/media/groundingSystem.3b4cd78d63aa1e44d97bc9c37683667d.svg";
export { ForwardRef as ReactComponent };